'use strict';

const dayjs = require('dayjs');
require('dayjs/locale/bg');
const isoWeek = require('dayjs/plugin/isoWeek');
dayjs.extend(isoWeek);
dayjs.locale('bg');

const getDays = () => {
	const today = dayjs();
	const endOfMonth = today.endOf('month');

	let iterator = today.startOf('month').startOf('isoWeek');
	let days = [];

	while (iterator.valueOf() < endOfMonth.valueOf()) {
		let weekdays = [];
		for (let i = 0; i < 7; i++) {
			weekdays.push(iterator.date());
			iterator = iterator.add(1, 'day');
		}
		days.push(weekdays);
	}
	return days;
};

const {
	section, h1, h2, h3, hr, header, i, ul, li,
	table, thead, tbody, tr, td, th, button
} = require('iblokz-snabbdom-helpers');

module.exports = ({state, actions}) => section('.calendar', [
	table([
		thead([
			tr([
				th([button('.fa.fa-step-backward')]),
				th([button('.fa.fa-backward')]),
				th({
					attrs: {
						colspan: 3
					},
					style: {
						textTransform: 'capitalize'
					}
				}, dayjs().format('MMMM YYYY')),
				th([button('.fa.fa-forward')]),
				th([button('.fa.fa-step-forward')])
			]),
			tr(['Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб', 'Нед'].map(wday =>
				th(wday)
			))
		]),
		tbody(getDays().map(week =>
			tr(
				week.map(day =>
					td(day)
				)
			))
		)
	])
]);
